<template>
  <div class="container">
    <h3>{{ i18n.t('/Dashboard/Headers/Quotes Overview Title') }}</h3>

    <quote-overview-filter @update="onUpdateFilters" />

    <div class="overview-block">
      <div class="header row">
        <div class="title">{{ i18n.t('/Dashboard/Headers/Name') }}</div>
        <div class="customer">{{ i18n.t('/Dashboard/Headers/Customer') }}</div>
        <div class="salesemployee">
          {{ i18n.t('/Dashboard/Headers/Employee') }}
        </div>
        <div class="status">{{ i18n.t('/Dashboard/Headers/Status') }}</div>
        <div class="actions" />
      </div>
      <ul>
        <quote-overview-row v-for="quote in quotes" :key="quote.Id" :quote="quote" />
      </ul>
    </div>

    <div class="loaderWrapper">
      <loader v-if="isLoading" />
    </div>

    <div>
      <app-button
        data-qa="load-more-quotes-button"
        type="button"
        button-type="primary"
        data="load-more-quotes"
        @click="loadMore()"
        >{{ i18n.t('/Dashboard/LoadMore') }}</app-button
      >
    </div>
  </div>
</template>

<script>
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import QuoteOverviewRow from '@/components/generic/presentational/organisms/quoteOverview/QuoteOverviewRow.vue'
import QuoteOverviewFilter from '@/components/generic/presentational/organisms/quoteOverview/QuoteOverviewFilter.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import { mapState } from 'vuex'
import quoteOrderService from '@/services/quoteOrderService.js'

export default {
  components: {
    Loader,
    QuoteOverviewRow,
    QuoteOverviewFilter,
    AppButton,
  },
  props: {
    establishmentId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      currentPage: 1,
    }
  },
  computed: mapState('quotes', {
    quotes: (state) => state.quotes,
    showQuotesAcrossEstablishments: (state) => state.showQuotesAcrossEstablishments,
    showColleagueQuotes: (state) => state.showColleagueQuotes,
    searchQuery: (state) => state.searchQuery,
    statusFilter: (state) => state.statusFilter,
    amountToShow: (state) => state.amountToShow,
  }),
  watch: {
    async establishmentId() {
      this.currentPage = 1
      await this.fetchQuotes()
    },
  },
  async created() {
    await this.fetchQuotes()
  },
  methods: {
    async loadMore() {
      this.currentPage++
      await this.fetchQuotes()
    },
    async onUpdateFilters() {
      this.currentPage = 1
      await this.fetchQuotes()
    },
    async fetchQuotes() {
      this.isLoading = true

      const establishmentId = this.showQuotesAcrossEstablishments ? '' : this.establishmentId
      const ponId = this.showColleagueQuotes ? '' : window.info.user.UserInfo.UserName
      const query = this.searchQuery.length > 0 ? this.searchQuery : null
      const status = this.statusFilter
      const size = this.i18n.t('/Dashboard/Quotes/QuotePageSize')

      if (this.currentPage == 1) {
        quoteOrderService.resetQuotes()
      }

      await quoteOrderService.getQuotes(
        establishmentId,
        this.currentPage,
        size,
        ponId,
        status,
        query
      )
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  @include center;
  display: grid;
  row-gap: 20px;
}

:deep() {
  .row {
    border-bottom: 1px solid #dae2e5;
    padding: 0.5rem;
    grid-column-gap: 0.5rem;
    display: grid;
  }

  .row {
    grid-template-columns: 13fr repeat(3, 10fr) 9fr;
    grid-template-areas: 'title customer salesemployee status actions';
  }

  li.row:hover {
    background-color: #fafbfc;
    cursor: pointer;
  }
}

.header {
  background-color: #f1f4f5;
  font-weight: $font-weight-bold;
}

ul {
  list-style: none outside;
}

.loaderWrapper {
  display: grid;
}

.filter-overview {
  display: grid;
  grid-auto-flow: column;
  column-gap: 1em;
  align-items: center;
}
</style>
